var map = {
	"./bida.json": 17,
	"./breyta.json": 350,
	"./brjota.json": 547,
	"./drekka.json": 185,
	"./eiga.json": 181,
	"./elda.json": 893,
	"./fa.json": 390,
	"./fara.json": 731,
	"./ganga.json": 367,
	"./geta.json": 900,
	"./hafa.json": 941,
	"./hlusta.json": 360,
	"./labba.json": 651,
	"./reyna.json": 268,
	"./saekja.json": 754,
	"./segja.json": 65,
	"./skilja.json": 157,
	"./skipta.json": 327,
	"./skrifa.json": 485,
	"./sofa.json": 296,
	"./thurfa.json": 929,
	"./vakna.json": 926,
	"./vera.json": 351,
	"./vinna.json": 257,
	"./vita.json": 701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;